import IframePage from "./IframePage";

export default IframePage;
